// https://www.iconfinder.com/iconsets/material-core

export const SettingIcon: React.FC = () => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_18_108)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.9 11C17.9 10.7 18 10.4 18 10C18 9.6 18 9.3 17.9 9L20 7.3C20.2 7.1 20.2 6.9 20.1 6.7L18.1 3.2C18 3.1 17.8 3 17.5 3.1L15 4.1C14.5 3.7 13.9 3.4 13.3 3.1L12.9 0.5C13 0.2 12.7 0 12.5 0H8.49997C8.29997 0 7.99997 0.2 7.99997 0.4L7.59997 3.1C6.99997 3.3 6.49997 3.7 5.89997 4.1L3.49997 3.1C3.19997 3 2.99997 3.1 2.79997 3.3L0.799973 6.8C0.699973 6.9 0.799973 7.2 0.999973 7.4L3.09997 9C3.09997 9.3 2.99997 9.6 2.99997 10C2.99997 10.4 2.99997 10.7 3.09997 11L0.999973 12.7C0.799973 12.9 0.799973 13.1 0.899973 13.3L2.89997 16.8C2.99997 16.9 3.19997 17 3.49997 16.9L5.99997 15.9C6.49997 16.3 7.09997 16.6 7.69997 16.9L8.09997 19.5C8.09997 19.7 8.29997 19.9 8.59997 19.9H12.6C12.8 19.9 13.1 19.7 13.1 19.5L13.5 16.9C14.1 16.6 14.7 16.3 15.2 15.9L17.7 16.9C17.9 17 18.2 16.9 18.3 16.7L20.3 13.2C20.4 13 20.4 12.7 20.2 12.6L17.9 11ZM10.5 13.5C8.59997 13.5 6.99997 11.9 6.99997 10C6.99997 8.1 8.59997 6.5 10.5 6.5C12.4 6.5 14 8.1 14 10C14 11.9 12.4 13.5 10.5 13.5Z"
          fill="#757575"
        />
      </g>
      <defs>
        <clipPath id="clip0_18_108">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const ThumbUpIcon: React.FC = () => {
  return (
    <svg
      width="22"
      height="20"
      viewBox="0 0 22 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_29_162)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 20H4V8H0V20ZM22 9C22 7.9 21.1 7 20 7H13.7L14.7 2.4V2.1C14.7 1.7 14.5 1.3 14.3 1L13.2 0L6.6 6.6C6.2 6.9 6 7.4 6 8V18C6 19.1 6.9 20 8 20H17C17.8 20 18.5 19.5 18.8 18.8L21.8 11.7C21.9 11.5 21.9 11.2 21.9 11V9H22Z"
          fill="#757575"
        />
      </g>
      <defs>
        <clipPath id="clip0_29_162">
          <rect width="22" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const ThumbDownIcon: React.FC = () => {
  return (
    <svg
      width="22"
      height="20"
      viewBox="0 0 22 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_29_176)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14 0H5C4.2 0 3.5 0.5 3.2 1.2L0.2 8.3C0.1 8.5 0 8.7 0 9V10.9V11C0 12.1 0.9 13 2 13H8.3L7.3 17.6V17.9C7.3 18.3 7.5 18.7 7.7 19L8.8 20L15.4 13.4C15.8 13 16 12.5 16 12V2C16 0.9 15.1 0 14 0ZM18 0V12H22V0H18Z"
          fill="#757575"
        />
      </g>
      <defs>
        <clipPath id="clip0_29_176">
          <rect width="22" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const HomeIcon: React.FC = () => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_18_139)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.5 18V12H12.5V18H17.5V10H20.5L10.5 1L0.5 10H3.5V18H8.5Z"
          fill="#757575"
        />
      </g>
      <defs>
        <clipPath id="clip0_18_139">
          <rect
            width="20"
            height="19"
            fill="white"
            transform="translate(0.5 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
